import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { createActionCreator } from '../../../../../utils/fsa';
import { SendStatus } from '../component/subscription_form';
import { ISubmitForm } from '../component/subscription_form_container';
import { IComponentState } from '../index';
import { ISubscriptionFormState } from '../reducer/index';

export const pendingSubscriptionForm = createActionCreator<ISubscriptionFormState>('subscriptionform/pending');

export const successSubscriptionForm = createActionCreator<ISubscriptionFormState>('subscriptionform/success');

export const failedSubscriptionForm = createActionCreator<ISubscriptionFormState>('subscriptionform/failed');

export const resetSubscriptionForm = createActionCreator<{}>('subscriptionform/reset');

export const submitSubscriptionForm =
  (onSubmit: ISubmitForm, email: string, successCallback?: () => void):
  ThunkAction<Promise<any>, IComponentState, any>  =>
    (dispatch: Dispatch<IComponentState>, getState: () => IComponentState, extraArgument: any) => {
      dispatch(pendingSubscriptionForm({
        status: SendStatus.REQUEST_PENDING,
        email,
      }));

      return onSubmit(email)
        .then((res) => {
          if (successCallback) {
            successCallback();
          }
          dispatch(successSubscriptionForm({
            status: SendStatus.SUCCESS,
            reqRes: res,
          }));
        })
        .catch((err) => {
          let errorText: string;
          if (err instanceof Error) {
            // tslint:disable-next-line:no-any
            (window as any).Raven.captureException(err);
            errorText = 'Не удалось оформить подписку. Попробуйте снова.';
          }
          if (typeof err === 'string') {
            errorText = err;
          }
          dispatch(failedSubscriptionForm({
            status: SendStatus.REQUEST_FAILED,
            errorText,
          }));
        });
    };



// WEBPACK FOOTER //
// ./src/bundles/common/components/subscription_form/actions/index.ts